import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import Gallery from '../../Gallery/Gallery';
import withResponsiveWrapper from '../../../decorators/withResponsiveWrapper';
import Slider from '../../Slider/Slider';

// eslint-disable-next-line css-modules/no-unused-class
import s from '../ProductInfo.scss';

const ProductImageGallery = ({
  title,
  gallery,
  isTouchCapable,
  isSmallScreen,
  isMobile,
}) => {
  const [lightbox, setLightbox] = useState({ photoIndex: '', isOpen: false });

  const mainImageSource = gallery[lightbox.photoIndex]?.thumbnail;
  const nexImageSource =
    gallery[(lightbox.photoIndex + 1) % gallery.length]?.thumbnail;
  const prevImageSource =
    lightbox.photoIndex > 0
      ? gallery[(lightbox.photoIndex + gallery.length - 1) % gallery.length]
          ?.thumbnail
      : gallery[gallery.length - 1]?.thumbnail;

  const onCloseLightbox = () => {
    setLightbox({ ...lightbox, isOpen: false });
  };

  // const onOpenLightbox = index => {
  //   setLightbox({ photoIndex: index, isOpen: true });
  // };

  const nextImage = () => {
    setLightbox({
      ...lightbox,
      photoIndex: (lightbox.photoIndex + 1) % gallery.length,
    });
  };

  const prevImage = () => {
    setLightbox({
      ...lightbox,
      photoIndex:
        lightbox.photoIndex > 0
          ? (lightbox.photoIndex - 1) % gallery.length
          : gallery.length - 1,
    });
  };

  let visibleSlides = 1;
  if (gallery && gallery.length > 1) {
    visibleSlides = isSmallScreen ? 2.5 : 1.5;
  }

  return (
    <>
      {lightbox.isOpen && gallery.length > 0 && (
        <Lightbox
          mainSrc={mainImageSource}
          nextSrc={nexImageSource}
          prevSrc={prevImageSource}
          onCloseRequest={() => onCloseLightbox()}
          onMovePrevRequest={() => prevImage()}
          onMoveNextRequest={() => nextImage()}
        />
      )}
      {isMobile ? (
        <Slider
          naturalSlideHeight={100}
          visibleSlides={visibleSlides}
          arrows={!isTouchCapable}
          hoverArrows={!isTouchCapable}
          responsive={false}
          className={s.slider}
          infinite
          darkBackground
          ariaLabel="Product image"
        >
          {gallery &&
            gallery.length > 0 &&
            gallery.map(({ source }) => (
              <img
                key={source}
                src={source}
                alt={title}
                crossOrigin="anonymous"
                style={{ maxHeight: '225px', objectFit: 'contain' }}
              />
            ))}
        </Slider>
      ) : (
        <Gallery>
          {gallery &&
            gallery.length > 0 &&
            gallery.map(({ source }) => {
              return (
                <img
                  key={source}
                  src={source}
                  alt={title}
                  crossOrigin="anonymous"
                />
              );
            })}
        </Gallery>
      )}
    </>
  );
};

export default compose(
  withResponsiveWrapper(),
  withStyles(s),
)(ProductImageGallery);

ProductImageGallery.propTypes = {
  title: PropTypes.string.isRequired,
  gallery: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isTouchCapable: PropTypes.bool.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
